<template>
  <SolutionPageLayout title="Corporate Events" section="Type">
    <p>
      Internal and client-facing corporate events need discretion, brand consistency, and flexible access—from invite-only sessions to hybrid town halls.
    </p>
    <p>
      Entegy gives you enterprise-ready workflows for registration, badging, apps, and on-site operations without compromising the polish your stakeholders expect.
    </p>
  </SolutionPageLayout>
</template>

<script setup>
import SolutionPageLayout from './SolutionPageLayout.vue'
</script>
